import posthog from 'posthog-js'
import { booking, siteName } from '../config/siteSettings'

// Helper function to get UTM parameters
const getUtmParam = (param: string): string | null => {
  if (typeof window === 'undefined') return null
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get(param)
}

const bookDemo = (buttonLocation: string = 'unknown') => {
  // Get page load time if available or use current time as fallback
  const pageLoadTime = (window as any).pageLoadTime || Date.now()
  const timeSpentOnPage = (Date.now() - pageLoadTime) / 1000 // in seconds
  
  // push an event to posthog with enhanced parameters
  posthog.capture('Book Demo', {
    // Basic info
    name: 'Book Demo',
    url: booking.calendlyUrl,
    siteName: siteName,
    
    // Current page information
    currentPage: window.location.pathname,
    
    // Campaign Attribution (current page UTMs, not initial landing)
    utmSource: getUtmParam('utm_source'),
    utmMedium: getUtmParam('utm_medium'),
    utmCampaign: getUtmParam('utm_campaign'),
    
    // Interaction Details
    buttonLocation: buttonLocation,
    timeSpentOnPage: timeSpentOnPage,
  })

  window.open(booking.calendlyUrl, '_blank')
}

export { bookDemo }
